import React, { Fragment, FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { localize } from "src/l10n";

interface IProps {
    notification: Spintr.INotification;
}

const tagByType: { [key: number]: string } = {
    82: "ACADEMY_COURSE_REOPENED_NOTIFICATION",
    83: "ACADEMY_COURSE_EXPIRED_NOTIFICATION",
    84: "ACADEMY_COURSE_ASSIGNED_NOTIFICATION",
    85: "ACADEMY_COURSE_ASSIGNMENT_DUE7_NOTIFICATION",
    86: "ACADEMY_COURSE_ASSIGNMENT_DUE3_NOTIFICATION",
    87: "ACADEMY_COURSE_ASSIGNMENT_DUE_TODAY_NOTIFICATION",
    88: "ACADEMY_COURSE_ASSIGNMENT_OVERDUE_NOTIFICATION",
};

const deadlineTagByType: { [key: number]: string } = {
    84: "ACADEMY_COURSE_ASSIGNED_DEADLINE_NOTIFICATION",
};

const AcademyCourseNotification: FunctionComponent<IProps> = (props) => {
    const notification = props.notification as Spintr.IAcademyCourseNotification;

    if (!notification) {
        return null;
    }

    const tag = (notification.deadline && deadlineTagByType[notification.type]) || tagByType[notification.type];

    if (!tag) {
        return null;
    }

    const localized = localize(tag);

    if (localized === tag) {
        return <Fragment>{notification.text}</Fragment>;
    }

    const template = localized.replace("{deadline}", notification.deadline || "");
    const [before, after = ""] = template.split("{name}");

    return (
        <Fragment>
            {before}
            <Link to={notification.url}>
                {notification.objectName}
            </Link>
            {after}
        </Fragment>
    );
};

export default AcademyCourseNotification;
